import React, { useState } from "react";
import styled from "styled-components";
import SearchBar from "ui/components/Dashboard/Filter/Searchbar";
import { Pagination } from "antd";
import { useGetOrganizer } from "lib/hooks";
import OrganizerCard from "./organizerCard";

const Container = styled.div`
  margin: 1rem;
  display: flex;
  flex-direction: column;
`;

const EventsContainer = styled.div`
  margin: 1rem;
  display: flex;
  flex-direction: column;
`;

const TopLine = styled.div`
  margin-top: -1.4rem;
`;

const Header = styled.h2`
  font-size: 32px;
  font-weight: 600;
  text-align: left;
  margin-top: 0;
  @media (max-width: 1024px) {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    text-align: left;
  }
`;

const OrganizerCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 800px;
`;

const Bottom = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  margin-top: 1.5rem;
  @media (max-width: 1024px) {
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  }
`;

const OrganizersHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 800px;
  background-color: #f9faff;
  border-radius: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-bottom: 2rem;
`;

const FullName = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 29%;
  padding-left: 16px;
`;
const EmailAdress = styled.div`
  width: 29%;
`;
const PhoneNumber = styled.div`
  width: 19.5%;
`;
const DateTime = styled.div`
  width: 20%;
`;

const HeaderText = styled.p`
  margin: 0;
  font-size: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #2f2f2f;
  display: flex;
  align-items: left;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;

  @media (max-width: 1024px) {
    font-size: 12px;
  }
`;

const AdminOrganizers: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const payload = {
    page: currentPage,
    limit: pageSize,
    search: searchQuery,
  };

  const { data, isLoading, isError } = useGetOrganizer(payload);

  const startingNumber = (currentPage - 1) * pageSize + 1;

  return (
    <Container>
      <TopLine>
        <Header>Organizers</Header>
      </TopLine>
      <SearchBar onSearch={handleSearch} />
      <Bottom>
        <OrganizersHeader>
          <FullName>
            <HeaderText>#</HeaderText>
            <HeaderText>Full Name</HeaderText>
          </FullName>
          <EmailAdress>
            <HeaderText>Email Address</HeaderText>
          </EmailAdress>
          <PhoneNumber>
            <HeaderText>Phone Number</HeaderText>
          </PhoneNumber>
          <DateTime>
            <HeaderText>Date Created</HeaderText>
          </DateTime>
        </OrganizersHeader>
        {isLoading ? (
          <p>Loading...</p>
        ) : isError ? (
          <p>Error loading organizers</p>
        ) : (
          <OrganizerCardContainer>
            {data?.data.map((organizer, index) => (
              <OrganizerCard key={organizer.id} organizer={organizer} number={startingNumber + index} />
            ))}
          </OrganizerCardContainer>
        )}

        {!isLoading && !isError && data?.data.length && (
          <PaginationContainer>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={data?.totalCount || 0}
              onChange={page => setCurrentPage(page)}
              size="small"
            />
          </PaginationContainer>
        )}
      </Bottom>
    </Container>
  );
};

export default AdminOrganizers;
